/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alert_Brave_Firefox_FryInputs */

const en_alert_brave_firefox_fry = /** @type {(inputs: Alert_Brave_Firefox_FryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relative`)
};

const de_alert_brave_firefox_fry = /** @type {(inputs: Alert_Brave_Firefox_FryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relativ`)
};

/**
* | output |
* | --- |
* | "Relative" |
*
* @param {Alert_Brave_Firefox_FryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const alert_brave_firefox_fry = /** @type {((inputs?: Alert_Brave_Firefox_FryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alert_Brave_Firefox_FryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_alert_brave_firefox_fry(inputs)
	return de_alert_brave_firefox_fry(inputs)
});